import {AfterViewInit, Component, inject, signal, WritableSignal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SuperObjectModel} from "../../core/definitions/super-object-model";
import {TranslatePipe} from "@ngx-translate/core";
import {MatButton} from "@angular/material/button";
import {ObjectPageQrCode} from "../object-page-qr-code/object-page-qr-code";
import {MatCheckbox} from "@angular/material/checkbox";

export interface QrCodeDialogParams {
    artifact: SuperObjectModel;
}

export interface QrCodeExtraDataOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-object-page-qr-code-dialog',
  imports: [
    TranslatePipe,
    MatButton,
    ObjectPageQrCode,
    MatCheckbox
  ],
  templateUrl: './object-page-qr-code-dialog.html',
  styleUrl: './object-page-qr-code-dialog.scss',
})
export class ObjectPageQrCodeDialog implements AfterViewInit {
  private readonly data: QrCodeDialogParams = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<ObjectPageQrCodeDialog> = inject(MatDialogRef);

  displayExtraData: WritableSignal<QrCodeExtraDataOption[]> = signal([]);
  extraDataOptions: WritableSignal<QrCodeExtraDataOption[]> = signal([]);

  ngAfterViewInit() {
    this.initialize();
  }

  get artifactId(): string {
    return this.data.artifact.artifact_id;
  }

  get artifactName(): string {
    return this.data.artifact.artifact_name;
  }

  cancelPrintDialog(): void {
    this.dialogRef.close();
  }

  optionChecked(option: QrCodeExtraDataOption) {
    if (this.displayExtraData().includes(option)) {
      this.displayExtraData.update(old => old.filter(o => o !== option));
    }
    else {
      this.displayExtraData.update(old => [...old, option]);
    }
  }

  togglePrintWindow(): void {
    window.print();
  }

  private initialize(): void {
    let extraOptions: QrCodeExtraDataOption[] = [];

    if (this.data.artifact.object_type === 'package') {
      if (this.data.artifact.description.description) {
        extraOptions.push({
          label: 'TRANS__QR_CODE_DIALOG__PACKAGE_DESCRIPTION',
          value: this.data.artifact.description.description
        });
      }
    }
    // @ts-ignore
    else if (this.data.artifact.designations?.length) {
      extraOptions.push({
        label: 'TRANS__QR_CODE_DIALOG__OBJECT_DESIGNATION',
        // @ts-ignore
        value: this.data.artifact.designations[0].designation_id_value
      });
    }

    if (extraOptions.length) {
      this.extraDataOptions.set(extraOptions);
    }
  }
}
